var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.props.icon === 'export')?_c('span',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/img/icons/opportunities/export.svg")}})]):_vm._e(),(_setup.props.icon === 'success')?_c(_setup.ExportIconSuccess,{staticClass:"icon icon-success"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }